module.exports = __webpack_public_path__ + "static/media/icon-body-graphics.07211c99.svg";